// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ffield {
  min-width: 50px;
}

.flexFull {
  flex: 1 1 100%;
}

.flex-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1px;
  background: #e5e5e5;
  border: 1px solid #e5e5e5;
  overflow: hidden;
}
.flex-grid .grid-box {
  flex: 1 1 32%;
  padding: 1px 3px;
  text-align: center;
  background: #fff;
  position: relative;
  z-index: 200;
}
.flex-grid .grid-box .title1 {
  font-size: 12px;
  font-weight: bold;
}
.flex-grid .grid-box .absolute-icon {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 20px;
}
.flex-grid .grid-box ion-select {
  padding: 0;
}
.flex-grid .grid-box .input-option {
  position: absolute;
  top: 0;
  left: -2px;
}
.flex-grid .grid-box .input-option ion-badge {
  margin: 0;
  padding: 2px 9px;
  height: auto;
  background: #fff;
  color: #3b3b3b;
  border: 1px solid #f2f2f2;
  border-radius: 11px;
  /* box-shadow: 0px 0px 5px -1px #000; */
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.14), 0 0px 0px 0 rgba(0, 0, 0, 0.12);
}
.flex-grid .grid-box.disable {
  background-image: linear-gradient(#fcfcfc, #f3f3f3) !important;
}
.flex-grid .grid-box.active {
  background: var(--button-a-background);
  color: var(--button-a-text);
}
.flex-grid .grid-box.italic {
  font-size: 12px;
}
.flex-grid .grid-box.bold {
  font-size: inherit;
}
.flex-grid .grid-box.error {
  color: red;
}
.flex-grid .grid-box.error.active {
  background: red;
  color: white !important;
}

.extraInfo {
  order: 5;
  display: flex;
  justify-content: center;
  padding: 2px;
}

.input-box ion-button {
  margin: 0;
  --padding-bottom: 0;
  --padding-top: 0;
  --padding-start: 0;
  --padding-end: 0;
  height: 21px;
}
.input-box ion-chip {
  padding: 0;
  --min-height: 0;
  margin: 0;
  height: -moz-fit-content;
  height: fit-content;
}

.amount-box {
  line-height: 1;
}
.amount-box i {
  font-size: 10px;
  white-space: nowrap;
}

.keyboard-input {
  height: 0;
  border: 0;
  position: absolute;
  color: transparent;
  padding: 0;
  z-index: -50;
  caret-color: transparent;
}

.edit-box {
  width: 100%;
  right: 0;
  top: 0;
  height: 100%;
  position: absolute;
}

.extraField-name .extraField-content, .extraField-code .extraField-content {
  justify-content: center;
}

.extraField-content {
  display: flex;
  align-items: center;
  height: 100%;
  flex-direction: column;
}
.extraField-content .title {
  font-weight: bold;
}
.extraField-content .value {
  overflow: auto;
  line-height: 1;
}
.extraField-content .value::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/item/components/item-agent-tool/item-agent-tool.component.scss"],"names":[],"mappings":"AAKA;EACE,eAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAJF;AAQE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AANJ;AAQI;EACE,eAAA;EACA,iBAAA;AANN;AAaI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;AAXN;AAcI;EACE,UAAA;AAZN;AAeI;EACE,kBAAA;EACA,MAAA;EACA,UAAA;AAbN;AAeM;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,uCAAA;EACA,+GAAA;AAbR;AAkBE;EAEE,8DAAA;AAjBJ;AAqBE;EAGE,sCAAA;EACA,2BAAA;AArBJ;AAwBE;EACE,eAAA;AAtBJ;AAyBE;EACE,kBAAA;AAvBJ;AA0BE;EACE,UAAA;AAxBJ;AA2BE;EACE,eAAA;EACA,uBAAA;AAzBJ;;AAuGA;EACE,QAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AApGF;;AAwGE;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AArGJ;AAwGE;EACE,UAAA;EACA,eAAA;EACA,SAAA;EACA,wBAAA;EAAA,mBAAA;AAtGJ;;AA0GA;EACE,cAAA;AAvGF;AAwGE;EACE,eAAA;EACA,mBAAA;AAtGJ;;AA0GA;EACI,SAAA;EACA,SAAA;EACA,kBAAA;EAEA,kBAAA;EACA,UAAA;EACA,YAAA;EAIA,wBAAA;AA3GJ;;AA8GA;EAGE,WAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;AA7GF;;AAkHE;EACE,uBAAA;AA/GJ;;AAmHA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;AAhHJ;AAkHE;EACE,iBAAA;AAhHJ;AAkHE;EACE,cAAA;EACA,cAAA;AAhHJ;AAmHE;EACE,aAAA;AAjHJ","sourcesContent":[".ffieldborder {\n  //border: 1px solid #8fb3b3;\n  //max-width: 120px;\n}\n\n.ffield {\n  min-width: 50px;\n}\n\n.flexFull {\n  flex: 1 1 100%;\n}\n\n.flex-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1px;\n  background: #e5e5e5;\n  border: 1px solid #e5e5e5;\n  overflow: hidden;\n  //border-right-width: 0;\n  //border-left: 0;\n\n  .grid-box {\n    flex: 1 1 32%;\n    padding: 1px 3px;\n    text-align: center;\n    background: #fff;\n    position: relative;\n    z-index: 200;\n\n    .title1 {\n      font-size: 12px;\n      font-weight: bold;\n    }\n\n    .title1.color-a {\n      //color: var(--button-a-background);\n    }\n\n    .absolute-icon {\n      position: absolute;\n      top: 0;\n      left: 0;\n      font-size: 20px;\n    }\n\n    ion-select {\n      padding: 0;\n    }\n\n    .input-option {\n      position: absolute;\n      top: 0;\n      left: -2px;\n\n      ion-badge {\n        margin: 0;\n        padding: 2px 9px;\n        height: auto;\n        background: #fff;\n        color: #3b3b3b;\n        border: 1px solid #f2f2f2;\n        border-radius: 11px;\n        /* box-shadow: 0px 0px 5px -1px #000; */\n        box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 1px 2px 0 rgb(0 0 0 / 14%), 0 0px 0px 0 rgb(0 0 0 / 12%);\n      }\n    }\n  }\n\n  .grid-box.disable {\n    //background-image: linear-gradient(white, #f9f9f9) !important;\n    background-image: linear-gradient(#fcfcfc, #f3f3f3) !important;\n    \n  }\n\n  .grid-box.active {\n    //box-shadow: 0 3px 6px -2px var(--main-top);\n    //position: sticky;\n    background: var(--button-a-background);\n    color: var(--button-a-text);\n  }\n\n  .grid-box.italic {\n    font-size: 12px;\n  }\n\n  .grid-box.bold {\n    font-size: inherit;\n  }\n\n  .grid-box.error{\n    color: red;\n  }\n\n  .grid-box.error.active{\n    background: red;\n    color: white !important;\n  }\n\n\n  //\n  //  ion-item.divion-item {\n  //    max-width: 150px;\n  //    --min-height: 40px;\n  //    //min-width: 50px;\n  //  }\n  //\n  //  .divion-item {\n  //\n  //    ion-label{\n  //      text-overflow: inherit;\n  //    }\n  //\n  //    ion-input, ion-select {\n  //      //font-weight: bolder;\n  //      --padding-top: 0;\n  //      --padding-bottom: 0;\n  //    }\n  //\n  //    ion-input, ion-select, ion-text{\n  //        height: 21px;\n  //        font-size: 16px;\n  //          white-space: nowrap;\n  //    }\n  //\n  //    ion-text{\n  //      //color: var(--ion-color-base);\n  //      //font-style: italic;\n  //    }\n  //  }\n  //\n  //  .divion-item input {\n  //    padding: 0;\n  //  }\n  //\n  //  .divion-item, ion-item {\n  //    flex: 0 0 31%;\n  //    flex-grow: 1;\n  //    //flex: 0 0 auto;\n  //    //flex-basis: 45%;\n  //\n  //    //ion-text {\n  //    //  padding: 8px 0;\n  //    //  color: #141414;\n  //    //}\n  //    //\n  //    //ion-text {\n  //    //  height: 37px;\n  //    //\n  //    //}\n  //\n  //    ion-icon {\n  //      margin: 0;\n  //      margin-top: 10px;\n  //      //padding: 0 20px;\n  //\n  //      position: absolute;\n  //      left: 0;\n  //    }\n  //  }\n  //\n  //  ion-item.danger {\n  //    color: var(--ion-color-danger);\n  //    --highlight-background: var(--highlight-color-invalid);\n  //  }\n  //\n  //  ion-item.active {\n  //\n  //    ion-input {\n  //      box-shadow: inset 0 -3px 0px var(--button-a-background);\n  //    }\n  //  }\n}\n\n.extraInfo {\n  order: 5;\n  display: flex;\n  justify-content: center;\n  padding: 2px;\n}\n\n.input-box {\n  ion-button {\n    margin: 0;\n    --padding-bottom: 0;\n    --padding-top: 0;\n    --padding-start: 0;\n    --padding-end: 0;\n    height: 21px;\n  }\n\n  ion-chip {\n    padding: 0;\n    --min-height: 0;\n    margin: 0;\n    height: fit-content;\n  }\n}\n\n.amount-box{\n  line-height: 1;\n  i{\n    font-size: 10px;\n    white-space: nowrap;\n  }\n}\n\n.keyboard-input{\n    height: 0;\n    border: 0;\n    position: absolute;\n    //max-width: 1px;\n    color: transparent;\n    padding: 0;\n    z-index: -50;\n    //opacity: 0;\n    //font-size: 0;\n    //overflow: hidden;\n    caret-color: transparent;\n}\n\n.edit-box{\n  //background: green;\n  //opacity: 0.2;\n  width: 100%;\n  right: 0;\n  top:0;\n  height: 100%;\n  position: absolute;\n  //z-index: 500;\n}\n\n.extraField-name, .extraField-code{\n  .extraField-content {\n    justify-content: center;\n  }\n}\n\n.extraField-content{\n    display: flex;\n    align-items: center;\n    height: 100%;\n    flex-direction: column;\n\n  .title{\n    font-weight: bold;\n  }\n  .value{\n    overflow: auto;\n    line-height: 1;\n  }\n\n  .value::-webkit-scrollbar {\n    display: none;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
